import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as stripeActions from "../../../actions/stripeActions";
import PageContainer from "../../Global/Containers/PageContainer";
import MaxWidthContainer from "../../Global/Containers/MaxWidthContainer";
import SecondaryMenu from "../../Global/Menus/SecondaryMenu";
import AccountMenu from "../AccountMenu";
import PaymentHistoryTable from "./PaymentHistoryTable";
import Pager from "../../Global/Pager/Pager";

class PaymentHistoryPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      loadingPayments: true,
      loadingPager: false,
      cursorList: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.paidHistoryArr !== nextProps.paidHistoryArr) {
      this.setState({
        loadingPager: false,
        loadingPayments: false,
      });
    }
  }

  handleNextClick = () => {
    this.setState({
      pageNumber: this.state.pageNumber + 1,
      loadingPager: true,
      loadingPayments: true,
      cursorList: this.state.cursorList.concat(this.props.paidHistoryCursor),
    });
    this.props.actions.getStripeCustomerPaymentHistory(
      this.props.paidHistoryCursor,
    );
  };

  handlePrevClick = () => {
    const { cursorList, pageNumber } = this.state;

    // 1. Remove last item in cursorList, which is the current data-set/page.
    this.setState(
      {
        cursorList: cursorList.slice(cursorList[0], cursorList.length - 1),
        pageNumber: pageNumber - 1,
        loadingPager: true,
        loadingPayments: true,
      },
      () => {
        // 2. Use callback to call API after cursorList is altered.
        this.getPrevHist();
      },
    );
  };

  getPrevHist = () => {
    const { cursorList } = this.state;

    // 3. Set prevCursor to last item in cursor array, which is now previous data-set/page cursor.
    let prevCursor = ``;
    if (cursorList.length > 0) {
      prevCursor = cursorList[cursorList.length - 1];
    }
    // 4. Call API passing previous data-set/page cursor.
    this.props.actions.getStripeCustomerPaymentHistory(prevCursor);
  };

  updateUserCard = () => {
    this.setState({
      loadingPayments: true,
    });
    this.props.actions.updateCard().then(() => {
      this.setState({
        loadingPayments: false,
      });
    });
  };

  render() {
    const {
      paidHistoryArr,
      paidHistoryCursor,
      futurePayment,
      loggedInUser,
    } = this.props;
    const { loadingPayments, loadingPager, pageNumber } = this.state;

    // Update card button
    const updateCC = (
      <div className="color-grey m-b-2 m-r-2 text-right">
        <button className="btn btn--tertiary" onClick={this.updateUserCard}>
          Update Card
        </button>
      </div>
    );

    // Next payment Logic
    let nextPayment;
    let nextPayAmount;

    if (loadingPayments || futurePayment === undefined) {
      nextPayment = ``;
    } else if (futurePayment.amount_due) {
      if (futurePayment.currency === `gbp`) {
        nextPayAmount = `£${futurePayment.amount_due}`;
      } else {
        nextPayAmount = `$${futurePayment.amount_due}`;
      }

      const nextPayTimeSplit = futurePayment.date.split(`T`);
      const nextPayDateSplit = nextPayTimeSplit[0].split(`-`);
      const nextPayDate = `${nextPayDateSplit[2]}-${nextPayDateSplit[1]}-${
        nextPayDateSplit[0]
      }`;
      nextPayment = (
        <p className="color-grey m-b-2 m-r-2">
          Your <span className="fw-bold">next payment</span> of {nextPayAmount}
          {` `}
          is due on {nextPayDate}
        </p>
      );
    }

    this.props.loggedInUser.stripe_plan = `something other than free`;

    // Disable Pager buttons logic for cursor API
    let showNextButton = true;
    let showPrevButton = true;

    if (paidHistoryCursor === null && pageNumber > 1) {
      showNextButton = false;
      showPrevButton = true;
    } else if (paidHistoryCursor !== null && pageNumber === 1) {
      showNextButton = true;
      showPrevButton = false;
    }

    return (
      <div id="payment-history-page">
        <PageContainer classes="bg-white">
          <SecondaryMenu>
            <AccountMenu
              active="payment-history"
              billingEnabled={loggedInUser.billing_enabled}
            />
          </SecondaryMenu>

          <MaxWidthContainer>
            <h1 className="like-h2 m-t-5 m-b-1">Payment History</h1>
            <p className="like-h5 color-grey max-width-paragraph m-b-5">
              Here you can view your payment history and download invoice
              details. If you require help please contact us at
              <a
                href="mailto:help@thecoachingmanual.com?Subject=Additional licences"
                className="link"
              >
                help@thecoachingmanual.com
              </a>
              .
            </p>

            <div className="d-flex justify-content-space-between align-items-flex-end">
              {nextPayment}

              {!loadingPayments && updateCC}
            </div>

            <PaymentHistoryTable
              paidHistoryArr={paidHistoryArr}
              loading={loadingPayments}
            />
            {/* pageNumber > 1 is needed to show buttons on last page, where there is no cursor */}
            {paidHistoryCursor || pageNumber > 1 ? (
              <Pager
                loading={loadingPager}
                showPrevButton={showPrevButton}
                showNextButton={showNextButton}
                onPrevClick={this.handlePrevClick}
                onNextClick={this.handleNextClick}
              />
            ) : null}
          </MaxWidthContainer>
        </PageContainer>
      </div>
    );
  }
}

PaymentHistoryPage.propTypes = {
  paidHistoryArr: PropTypes.array,
  paidHistoryCursor: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  futurePayment: PropTypes.object,
  actions: PropTypes.object,
  loggedInUser: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    paidHistoryArr: state.stripe.paidHistoryArr,
    paidHistoryCursor: state.stripe.paidHistoryCursor,
    futurePayment: state.stripe.futurePayment,
    loggedInUser: state.loggedInUser,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, stripeActions), dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentHistoryPage);



// WEBPACK FOOTER //
// ./library/app/components/Account/PaymentHistory/PaymentHistoryPage.js